import { render, staticRenderFns } from "./GPromotionCompleteModal.vue?vue&type=template&id=687d0504&scoped=true&"
import script from "./GPromotionCompleteModal.vue?vue&type=script&lang=ts&"
export * from "./GPromotionCompleteModal.vue?vue&type=script&lang=ts&"
import style0 from "./GPromotionCompleteModal.vue?vue&type=style&index=0&id=687d0504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687d0504",
  null
  
)

export default component.exports